import { connect } from 'react-redux';
import GenericLoader from '../util/GenericLoader';
import {
  getBuildingIngestStatsAction,
  getPointSampleRatesAction,
} from '../../redux/actions/ingestStats';

export default connect(null, (dispatch, { interval }) => ({
  fetchFunction: () => dispatch(getBuildingIngestStatsAction(interval)),
}))(GenericLoader);

export const PointSampleRatesLoader = connect(null, (dispatch, { buildingId, interval }) => ({
  fetchFunction: () => dispatch(getPointSampleRatesAction(buildingId, interval)),
}))(GenericLoader);
